<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles contractProgress">
            <van-nav-bar
                title="合同进度"
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
            >
                <van-icon
                    class="iconfont iconshaixuan"
                    slot="right"
                    @click="showPopup('screen')"
                ></van-icon>
            </van-nav-bar>
            <section>
                <!--<van-search v-model="SearchValue" placeholder="请输入搜索信息" @change="SearchChange"></van-search>-->
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <template>
                                <li v-for="(item,index) in listData" :key="index" :class="`item-${item.contract_type}`">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="state">{{ item.contract_type | contractType }}</span>
                                            <span class="headerName">合同编号：{{ item.contract_number }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>客户名称：{{ item.client_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>项目名称：{{ item.engineering_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>签订日期：{{ item.signing_date }}</span>
                                            </p>
                                        </div>
                                        <van-divider dashed></van-divider>
                                    </div>
                                    <div class="charts">
                                        <div class="chart">
                                            <van-circle
                                                class="van_left"
                                                v-model="item.currentRate"
                                                :rate="capacityRate(item)"
                                                :size="40"
                                                :speed="100"
                                                :text="capacityText(item)"
                                                color="#3495FB"
                                                layer-color="#d5e9fe"
                                                :stroke-width="100"
                                            ></van-circle>
                                            <div class="van_left legend estimate">
                                                <p>
                                                    预计方量:
                                                    <span>{{ item.projected_capacity }}m³</span>
                                                </p>
                                                <p>
                                                    已发方量:
                                                    <span>{{ item.delivery_total_quantity }}m³</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="chart">
                                            <van-circle
                                                class="van_left"
                                                v-model="item.currentRate2"
                                                :rate="amountRate(item)"
                                                :size="40"
                                                :speed="100"
                                                :text="amountText(item)"
                                                text-color="#F15742"
                                                color="#F15742"
                                                layer-color="rgba(255, 225, 225, 1)"
                                                :stroke-width="100"
                                            ></van-circle>
                                            <div class="van_left legend receivables">
                                                <p>
                                                    应收款:
                                                    <span>{{ item.sales_amount1 }}万</span>
                                                </p>
                                                <p>
                                                    已回款:
                                                    <span>{{ item.aggregate_official_receipt1 }}万</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form">
                                        <button @click="openProjectProgress(item)" :class="{'disableBtn': !item.engineering_id }">
                                            <img src="@/assets/images/icons/icon_2.png" alt="">
                                            施工
                                        </button>
                                        <button @click="openSupplyVolume(item)">
                                            <img src="@/assets/images/icons/icon_30.png" alt="">
                                            方量
                                        </button>
                                        <button @click="openRefundSchedule(item)">
                                            <img src="@/assets/images/icons/icon_26.png" alt="">
                                            款项
                                        </button>
                                        <button @click="openOverDelivery(item)">
                                            <img src="@/assets/images/icons/icon_gy_10.png" alt="">
                                            超发
                                        </button>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <van-popup
                class="sideslip"
                v-model="popupShow"
                position="right"
                :style="{ width: '80%',height: '100%' }"
            >
                <div class="screen">
                    <van-nav-bar
                        title="筛选"
                        right-text="取消"
                        @click-right="popupShow=false"
                    >
                    </van-nav-bar>
                    <section>
                        <dl>
                            <dt>搜索条件</dt>
                            <dd>
                                <van-field v-model="SearchValue" placeholder="请输入搜索信息"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>合同状态</dt>
                            <dd>
                                <span
                                    :class="{'active': item.contract_status===contract_status}"
                                    v-for="item in contractStatusLs"
                                    :key="item.contract_status"
                                    @click="changeContractStatus(item)"
                                >
                                    {{ item.name }}
                                </span>
                            </dd>
                        </dl>
                        <dl>
                            <dt>场站</dt>
                            <dd>
                                <span
                                    :class="{'active': item.station_id===station_id}"
                                    v-for="item in stationLs"
                                    :key="item.station_id"
                                    @click="handleSelectStation(item)"
                                >
                                    {{ item.name }}
                                </span>
                            </dd>
                        </dl>
                    </section>
                    <div class="bottom">
                        <div class="sure-btn" @click="SearchChange">
                            确定
                        </div>
                        <div class="reset-btn" @click="handleReset">
                            重置
                        </div>
                    </div>
                </div>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 合同进度
    name: 'contract-progress',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.keywords = '';
            this.$store.commit('noKeepAlive', 'contract-progress');
        }
        next();
    },
    components: {},
    props: {},
    data() {
        return {
            SearchValue: '',
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 分页
            page: {
                pageindex: 1,
                pagesize: 10,
            },
            // 列表数据
            listData: [],
            // 列表总条数
            total: 0,
            // 记录上拉还是下拉
            slidingDirection: '',
            // 是否是领导端
            isLeader: false,

            contract_status: '',
            contractStatusLs: [{ contract_status: '', name: '全部' }],
            // 场站列表
            stationLs: [{ station_id: '', name: '全部' }],
            station_id: '',
            popupShow: false,
        };
    },
    filters: {
        contractType(type) {
            const arr = {
                '102-LS1': '临时',
                '102-LS2': '零售',
                '102-XX0': '现销',
                '102-ZS0': '正式',
            };
            return arr[type];
        },
    },
    computed: {

    },
    watch: {},
    created() {
        // 是否是领导端
        this.isLeader = this.$route.query.leader;
        this.getStationData();
        this.getContractStatus();
    },
    mounted() {
    },
    destroyed() {},
    methods: {
        // 方量比例文字
        capacityText(item) {
            if (item.delivery_total_quantity === 0 || item.projected_capacity === 0) {
                return 0 + '%';
            }
            return Math.floor(item.delivery_total_quantity / item.projected_capacity * 100) + '%';
        },
        // 方量比例值
        capacityRate(item) {
            if (item.delivery_total_quantity === 0 || item.projected_capacity === 0) {
                return 0;
            }
            return Math.floor(item.delivery_total_quantity / item.projected_capacity * 100);
        },
        // 费用比例文字
        amountText(item) {
            if (item.sales_amount === 0 || item.aggregate_official_receipt === 0) {
                return 0 + '%';
            }
            return Math.floor(item.aggregate_official_receipt / item.sales_amount * 100) + '%';
        },
        // 费用比例值
        amountRate(item) {
            if (item.sales_amount === 0 || item.aggregate_official_receipt === 0) {
                return 0;
            }
            return Math.floor(item.aggregate_official_receipt / item.sales_amount * 100);
        },
        // 获取请求接口
        getApiField() {
            let url = '';
            if (this.$route.query.leader) {
                // 领导
                url = 'get_clients_leader_page';
            } else if (this.$route.query.areaLeader) {
                // 区域领导
                url = 'get_clients_area_leader_page';
            } else {
                url = 'get_clients_page';
            }
            return url;
        },
        getInit() {
            const url = this.getApiField();
            // 获取合同列表
            this.$axios
                .get(`/interfaceApi/sale/contract_progress/${url}?pageindex=` + this.page.pageindex
                    + '&pagesize=' + this.page.pagesize + '&Keywords=' + this.SearchValue
                    + '&station_id=' + this.station_id + '&contract_status=' + this.contract_status)
                .then(res => {
                    this.total = res.total;
                    res.rows = res.rows.map(item => {
                        if (item.sales_amount || item.sales_amount === 0) {
                            item.sales_amount1 = (Number(item.sales_amount) / 10000).toFixed(2);
                        }
                        if (item.aggregate_official_receipt || item.aggregate_official_receipt === 0) {
                            item.aggregate_official_receipt1 = (Number(item.aggregate_official_receipt) / 10000).toFixed(2);
                        }
                        return item;
                    });
                    if (this.listData.length < 1 || this.slidingDirection === 'down') {
                        this.listData = res.rows;
                        this.finished = false;
                    } else {
                        res.rows.forEach(item => {
                            this.listData.push(item);
                        });
                    }
                    if (this.listData.length === this.total) {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 下拉刷新
        onRefresh() {
            this.slidingDirection = 'down';
            this.page.pageindex = 1;
            this.getInit();
            this.page.pageindex++;
        },
        // 上拉加载更多
        onLoad() {
            this.slidingDirection = 'up';
            this.getInit();
            this.page.pageindex++;
        },
        // 搜索
        SearchChange() {
            this.slidingDirection = 'down';
            this.page.pageindex = 1;
            this.getInit();
            this.page.pageindex++;
            this.popupShow = false;
        },
        // 打开工程进度
        openProjectProgress(item) {
            if (item.engineering_id) {
                this.$router.isBack = 2;
                this.$router.push({ name: 'schedule', params: { obj: item } });
            } else {
                this.$toast('零售合同不包含工程信息');
            }
        },
        // 打开供应方量
        openSupplyVolume(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'supplyVolume', params: { obj: item } });
        },
        // 打开回款进度
        openRefundSchedule(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'refundSchedule', params: { obj: item } });
        },
        // 打开超限发货
        openOverDelivery(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'overDelivery', params: { obj: item } });
        },
        // 打开合同进度详情
        openContractDetails() {
            this.$router.isBack = 2;
            this.$router.push({ path: '/contractProgressDetails' });
        },

        // 展开筛选菜单
        showPopup() {
            this.popupShow = true;
        },
        // 选择筛选条件 场站
        handleSelectStation(item) {
            this.station_id = item.station_id;
        },
        // 重置
        handleReset() {
            this.SearchValue = '';
            this.station_id = '';
            this.contract_status = '';
        },
        // 获取场站数据
        getStationData() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.stationLs.push(...stationList);
            }
        },
        // 合同状态变更
        changeContractStatus(item) {
            this.contract_status = item.contract_status;
        },
        // 获取合同状态字典
        async getContractStatus() {
            const path = '/interfaceApi/sale/contract_manager/get_dictionary?groupCode=contract_status';
            this.$axios.get(path)
                .then(data => {
                    const list = data.map(item => {
                        return {
                            contract_status: item.dic_code,
                            name: item.dic_name,
                        };
                    });
                    this.contractStatusLs.push(...list);
                });
        },
    },
};
</script>
<style lang="stylus" scoped>
.contractProgress
    height 100%
    background #F0F0F0
    section
        height calc(100% - 45rpx)
        .van-pull-refresh
            height 100%
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .list
                li
                    .engineeringInfo
                        .engineeringInfo_content
                            margin-bottom: 0
                    .charts
                        height 80rpx
                        position relative
                        padding-left 10rpx
                        &:after
                            content ''
                            position absolute
                            width 1px
                            height 15rpx
                            background #F0F0F0
                            left 50%
                            top 50%
                            margin-top -7rpx
                        .chart
                            float left
                            height 100%
                            width 50%
                            padding 15rpx 0
                            .van-circle
                                margin-top 6rpx
                        .legend
                            width calc(100% - 50rpx)
                            padding-left 4rpx
                            p
                                font-size 10rpx
                                line-height 24rpx
                            &.estimate
                                span
                                    color #3495FB
                            &.receivables
                                span
                                    color #F15742
    .screen
        height 100%
        section
            height calc(100% - 85rpx)
            overflow scroll
            -webkit-overflow-scrolling touch
            dd
                margin-top 8rpx
                display flex
                flex-wrap wrap
                .van-field
                    border 1px solid #ddd
                    padding 6rpx 10rpx
                >span
                    width calc(33.33% - 10rpx)
                    background #F1F1F1
                    border 1px solid #F1F1F1
                    border-radius 6rpx
                    margin 0 10rpx 10rpx 0
                    font-size 14rpx
                    text-align center
                    padding 6rpx 0
                    display flex
                    justify-content center
                    align-items center
                    &:last-child
                        margin-right 0
                    &.active
                        border 1px solid #E60000
                        color #E60000
                        background #fff
                        position relative
                        &:after
                            position absolute
                            content ''
                            bottom 0
                            right -1px
                            width 20rpx
                            height 20rpx
                            background url(./../../../assets/images/contractInfo/pick.png) no-repeat
                            background-size 100% 100%
        .bottom
            height 40rpx
            display flex
            font-size 18rpx
            text-align center
            line-height 40rpx
            .sure-btn
                flex 1
                background #E60000
                height 100%
                border 1px solid #E60000
                color #fff
            .reset-btn
                flex 1
                height 100%
                border 1px solid #E60000
                color #E60000
</style>
